import { CdkDrag, CdkDragDrop, CdkDropList, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnInit, inject } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { MatDivider } from '@angular/material/list';
import { MatSelect } from '@angular/material/select';
import { IconModule, ScrollbarModule } from '@michelin/theme';
import { ApplicationGroup, Element } from 'src/app/interfaces/applicationGroup';
import { GroupModalService } from './group-modal.service';

@Component({
  selector: 'mic-app-group-modal',
  templateUrl: './group-modal.component.html',
  styleUrls: ['./group-modal.component.scss'],
  imports: [
    MatDialogTitle,
    MatIcon,
    MatDivider,
    MatFormField,
    MatLabel,
    MatSelect,
    ScrollbarModule,
    MatOption,
    ReactiveFormsModule,
    MatInput,
    CdkDropList,
    CdkDrag,
    IconModule,
    MatButton
  ]
})
export class GroupModalComponent implements OnInit {
  dialogRef = inject<MatDialogRef<GroupModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private readonly groupService = inject(GroupModalService);

  GroupTest: ApplicationGroup;

  groupElements: FormGroup;

  ngOnInit(): void {
    this.groupService.getApplicationGroupById(this.data).subscribe((response) => {
      this.GroupTest = response;
    });

    this.groupElements = new FormGroup(
      {
        name: new FormControl(''),
        groupElement: new FormArray([])
      },
      {
        validators: this.controlForms('name', 'groupElement')
      }
    );
  }

  private controlForms(controlNameA: string, controlNameB: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const formGroup = control as FormGroup;
      const valueOfControleA = formGroup.get(controlNameA)?.value;
      const valueOfControleB = formGroup.get(controlNameB)?.value;
      if (valueOfControleA !== '' && valueOfControleB.length >= 2) {
        return null;
      } else {
        return { valuesDoNotMatch: true };
      }
    };
  }

  /**
   * Adds an element (IMPORTFILECSV element)
   *
   * @param item - The element to add in the group.
   */
  onAddElement(item: Element) {
    const toto = new FormGroup({
      typeElement: new FormControl('IMPORTFILECSV'),
      orderElement: new FormControl(this.groupElements.value.groupElement.length + 1),
      functionElement: new FormControl(item.id),
      nameElement: new FormControl(item.name)
    });
    (this.groupElements.get('groupElement') as FormArray).push(toto);
  }

  /**
   * Adds an element (SCRIPT element)
   *
   * @param item - The element to add in the group.
   */
  onAddElementScript(item: Element) {
    const functionGroup = new FormGroup({
      typeElement: new FormControl('SCRIPT'),
      orderElement: new FormControl(this.groupElements.value.groupElement.length + 1),
      functionElement: new FormControl(item.id),
      nameElement: new FormControl(item.name)
    });
    (this.groupElements.get('groupElement') as FormArray).push(functionGroup);
  }

  /**
   * Adds an element (TABLE element)
   *
   * @param item - The element to add in the group.
   */
  onAddElementTable(item: Element): void {
    const tableFunctionGroup = new FormGroup({
      typeElement: new FormControl('TABLE'),
      orderElement: new FormControl(this.groupElements.value.length + 1),
      functionElement: new FormControl(item.id),
      nameElement: new FormControl(item.name)
    });
    (this.groupElements.get('groupElement') as FormArray).push(tableFunctionGroup);
  }

  get controls() {
    return (this.groupElements.get('groupElement') as FormArray).controls;
  }

  drop(event: CdkDragDrop<Element[]>) {
    transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    for (let index = 0; index < this.groupElements.value.groupElement.length; index++) {
      this.groupElements.value.groupElement[index].orderElement = index + 1;
    }
  }

  /**
   * Removes an element from the groupElements array at the specified index.
   *
   * @param i - The index of the element to remove.
   */
  onDelete(i: number) {
    (this.groupElements.get('groupElement') as FormArray).removeAt(i);
    (this.groupElements.get('groupElement') as FormArray).markAsDirty();
    for (let index = 0; index < this.groupElements.value.groupElement.length; index++) {
      this.groupElements.value.groupElement[index].orderElement = index + 1;
    }
  }

  onSubmit() {
    this.groupService.addGroupById(this.data, this.groupElements.value).subscribe(() => {
      this.onClose(null);
    });
  }

  onClose(close: boolean): void {
    this.dialogRef.close(close);
  }
}
